import React, { useEffect, useState } from 'react';

import { useNavigate } from '@remix-run/react';
import { ResourceCommentInputModel } from '@models/api';
import { BrowserCustomerClient } from '@client';
import { classNames, mixpanelService } from '@utilities';
import { CommentInputProps } from '../video-item-props';

const InputCommentComponent: React.FC<CommentInputProps> = ({ profilePicture, resourceId, parentCommentId, profileName, isAuthenticated, isSubscribed, videoHeader, videoTags }) => {
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();

  const [comment, setComment] = useState<string>('');

  const [profileImage, setProfileImage] = useState<string>('');
  useEffect(() => {
    if (profilePicture === '') {
      return;
    }

    (async () => {
      const client = new BrowserCustomerClient();
      const profileImgResp = await client.GetBucketFileUrl({ key: profilePicture });
      const profileImgUrl = profileImgResp.data;
      setProfileImage(profileImgUrl);
    })();
  }, [profilePicture]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== '') {
      setComment(event.target.value);
      setError('');
    }
  };

  const onCommentPost = async () => {
    if (comment.trim() === '') {
      setError('Please enter a comment');
      return;
    }

    const data: ResourceCommentInputModel = {
      resourceId: resourceId,
      comment: comment,
    };

    let eventType = "video_comment";
    let userStatus = 'visitor';
    if (isAuthenticated) userStatus = 'registered';
    if (isSubscribed) userStatus = 'subscriber';

    if (parentCommentId) {
      data.parentId = parentCommentId;
      eventType = "comment_comment";
    }
    
    try {
      const client = new BrowserCustomerClient();
      const response = await client?.SaveResourceComment(data);
      if (response?.success) {
        setComment('');
        setError('');
        mixpanelService.track(eventType, {
          video_name: videoHeader,
          tag_name:  videoTags, 
          user_status: userStatus,
        });
        navigate(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="post-section">
      <div className="post-content">
        <div className="">
          {profileImage !== '' ? <img src={profileImage} alt="profile_pic" className="w-[40px] h-[40px] rounded-3xl" /> : <p className="icon text-white"> {profileName[0]} </p>}
        </div>

        <input type="text" id="typing" name="typing" placeholder="" className="input-element" onChange={handleInputChange} />
      </div>
      {error && <div className="empty-comment-error">{error}</div>}
      <div className="post-button">
        <button className={classNames(comment !== '' ? 'button-section-active' : 'button-section')} onClick={onCommentPost}>
          <div className="button-text">
            <p className="text"> Post </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default InputCommentComponent;
